<template>
  <div id="new_user">
    <dd-header
      :isMenuView='false'
    />
    <div class="container">
      <div id="content">
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
          />
          <section v-if="!isInviteUser">
            <h2>お客様種別</h2>
            <div class="input_list user_type">
              <div>
                <span>お客様種別</span>
                <span class="important small_text">必須</span>
              </div>
              <div class="radio">
                <input type="radio" id="user_type_pri" name="usertype" :value="true" v-model="isUserType" @click="changeUserType"/>
                <label for="user_type_pri" class="radio-label bold">個人</label>
              </div>
              <div class="radio">
                <input type="radio" id="user_type_corp" name="usertype" :value="false" v-model="isUserType" @click="changeUserType"/>
                <label for="user_type_corp" class="radio-label bold">法人</label>
              </div>
            </div>
          </section>
          <dd-corp
            ref="corpInputRef"
            :isManager="true"
            :isPrivateUser="isPrivateUser"
            :corpForm="corpForm"
            v-if="!isInviteUser"
          />
          <dd-user
            ref="userInputRef"
            :isEdit="false"
            :isPrivateUser="isPrivateUser && !isInviteUser"
            :userForm="userForm"
          />
          <div class="scroll_rule">
            <dd-user-rule-detial />
          </div>
          <div id="consent">
            <ul>
              <li>
                <input type="checkbox" id="termsOfUse" v-model="userForm.consent"/>
                <label :for="'termsOfUse'">利用規約に同意する。</label>
              </li>
              <li>
                <input type="checkbox" id="mailMagazine" v-model="userForm.recvInfo"/>
                <label :for="'mailMagazine'">メールマガジンを受け取る。</label>
              </li>
            </ul>
          </div>
          <div :class="{'detail_btn': true, 'btn_pos_center': true, 'disabled': isDisabled }" @click="confirm()">入力情報の確認 〉〉</div>
        </div>
        <!-- <section>
          <div class="title">
            <h2>ユーザー情報入力</h2>
            <label>下記フォームより入力してください。</label>
          </div>
          <dd-user-input
            ref="userInputRef"
            :isEdit="false"
            :userForm="userForm"
            :isRequestPayment="isRequestPayment"
          />
        </section>
        <div class="control_btn_area">
          <div class="main_btn sel_sub_btn" @click="goBack()" v-if="isNewCorp">
            <a>戻る</a>
          </div>
          <div class="main_btn sel_main_btn" @click="confirm()" v-bind:disabled="isDisabled">
            <a>登録する</a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import DDLeftMenu from '../components/top/DcLeftMenu'
import SiteMap from '../components/common/DcSiteMap'
import DcCorpInfo from '../components/user/DcCorpInfo'
import DcUserInfo from '../components/user/DcUserInfo'
import DcUseRuleDetial from '../components/common/DcUseRuleDetial'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': SiteMap,
    'dd-corp': DcCorpInfo,
    'dd-user': DcUserInfo,
    'dd-user-rule-detial': DcUseRuleDetial
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'dcRegistInput',
      pageList: [
        {id: 'dcRegistInput', key: 'dcRegistInput', title: '会員情報入力'},
        {id: 'dcRegistConfirm', key: 'dcRegistConfirm', title: '内容確認'},
        {id: 'dcRegistComplete', key: 'dcRegistComplete', title: '登録完了'}
      ],
      corpForm: {
        corpId: '',
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        inviteCode: '',
        requestPayment: ''
      },
      saveCorpForm: {},
      userForm: {
        corpUserId: '',
        corpType: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: '',
        infosrc: '',
        inviteCode: '',
        recvInfo: false,
        consent: false,
        password: '',
        confirmPassword: ''
      },
      isRequestPayment: false,
      isUserType: true
    }
  },
  computed: {
    isNewCorp: function () {
      if (!this.userForm || this.userForm.corpUserId === undefined || this.userForm.corpUserId === '') {
        return true
      }
      return false
    },
    isDisabled: function () {
      if (this.userForm.consent === true) {
        return false
      }
      return true
    },
    isInviteUser: function () {
      if (this.userForm.corpUserId) {
        return true
      }
      return false
    },
    isPrivateUser: function () {
      if (this.isUserType) {
        return true
      }
      return false
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    confirm: function () {
      let retCorp
      if (!this.isInviteUser) {
        // 招待ユーザ以外の場合。招待ユーザは企業情報を既に持っている
        retCorp = this.$refs.corpInputRef.confirm()
      }
      let retUser = this.$refs.userInputRef.confirm()
      if (!retUser || (!this.isInviteUser && !retCorp)) return
      if (!this.isInviteUser) {
        if (this.isPrivateUser) {
          // 個人の場合
          this.$set(this.corpForm, 'corpName', undefined)
          this.$set(this.corpForm, 'corpBranchName', undefined)
          this.$set(this.userForm, 'corpType', undefined)
          this.$set(this.userForm, 'corpDept', undefined)
        } else {
          // 法人ユーザのチェック
          let retCorp = this.$refs.corpInputRef.confirm()
          if (!retCorp) return
        }
      }
      // ストレージに保存する
      App.setLocalStorage(DC_STORAGE_KEY.USER_TYPE, this.isUserType)
      App.setLocalStorage(DC_STORAGE_KEY.CORP_DATA, this.corpForm)
      App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)
      this.$router.push({
        name: 'RegistUserConfirm'
      })
    },
    tokenCheck: function () {
      let payload = {
        userEmail: this.$route.query.email,
        token: this.$route.query.token,
        corpUserId: this.$route.query.userId
      }
      axios.post(DC_URL.USER + '/new/check-new-user-token', payload
      ).then(response => {
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    changeUserType: function () {
      // 企業
      let lCorpForm = Object.assign({}, this.corpForm)
      this.corpForm = Object.assign({}, this.saveCorpForm)
      this.saveCorpForm = Object.assign({}, lCorpForm)
    }
  },
  mounted () {
  },
  created () {
    this.tokenCheck()
    // 企業情報の補完
    let letUserType = App.getLocalStorage(DC_STORAGE_KEY.USER_TYPE)
    if (!letUserType) this.isUserType = letUserType
    let lCorpForm = App.getLocalStorage(DC_STORAGE_KEY.CORP_DATA)
    if (Object.keys(lCorpForm).length > 0) {
      this.corpForm = Object.assign({}, lCorpForm)
      this.saveCorpForm = Object.assign({}, lCorpForm)
    } else {
      this.$set(this.corpForm, 'email', this.$route.query.email)
      this.$set(this.corpForm, 'inviteCode', this.$route.query.code)
      this.$set(this.corpForm, 'requestPayment', this.$route.query.payment)
      this.saveCorpForm = Object.assign({}, this.corpForm)
    }
    // ユーザ情報の補完
    let lUserForm = App.getLocalStorage(DC_STORAGE_KEY.USER_DATA)
    // POST
    if (Object.keys(lCorpForm).length > 0) {
      if (Object.keys(lUserForm).length > 0) {
        this.userForm = lUserForm
      } else {
        this.userForm.email = lCorpForm.email
      }
      this.isRequestPayment = lCorpForm.requestPayment
    } else {
      if (Object.keys(lUserForm).length > 0) {
        this.userForm = lUserForm
      } else {
        this.$set(this.userForm, 'email', this.$route.query.email)
        this.$set(this.userForm, 'corpUserId', this.$route.query.userId)
      }
    }
  }
}
</script>
<style src="../css/dc-userule.scss" lang="scss" scoped></style>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcRegistUserInput.vue